// eslint-disable-next-line import/no-cycle
import {
  CustomMutation, Get, Request,
} from '@/composables/GraphQL';
// eslint-disable-next-line import/no-cycle
import {
  CampaignsBulk,
  CampaignsBulkBase,
  CampaignsBulkDuplicateInputItem,
  CampaignsBulkSaveInputItem,
  Maybe,
} from '@/types/generated-types/graphql';
// eslint-disable-next-line import/no-cycle
import { CampaignsBulkStatusEnum } from '@/types';
// eslint-disable-next-line import/no-cycle
import { showToastError } from '@/helpers';
import { NestApiType, nestCall } from '@/composables/nestApi';

export async function saveBulkCampaign(campaignBulkSaveInput: CampaignsBulkSaveInputItem) {
  const {
    id, messages, err,
  } = await CustomMutation<CampaignsBulkSaveInputItem>({
    name: 'SaveCampaignsBulk',
    input: campaignBulkSaveInput,
    type: 'CampaignsBulkSaveInput',
  });

  if (err === '') {
    return {
      success: true,
      id,
    };
  }

  return {
    success: false,
    messages,
  };
}

export async function duplicateBulkCampaign(campaignBulkDuplicateInput: CampaignsBulkDuplicateInputItem) {
  const {
    id, messages, err,
  } = await CustomMutation<CampaignsBulkDuplicateInputItem>({
    name: 'DuplicateCampaignsBulk',
    input: campaignBulkDuplicateInput,
    type: 'CampaignsBulkDuplicateInput',
  });

  if (err === '') {
    return {
      success: true,
      id,
    };
  }

  return {
    success: false,
    messages,
  };
}

export async function fetchBaseCampaignsBulk() {
  const query = 'query'
    + '{ GetBaseCampaignsBulk {'
    + 'id_campaign_bulk_base, name, legend, categories, images_templates}}';
  const variables = {};

  const { data, err } = await Request<CampaignsBulkBase[]>({
    name: 'GetBaseCampaignsBulk',
    query,
    variables,
  });

  if (err || data === null || data.length === 0) {
    return [];
  }

  return data;
}

export async function getCampaignsBulkBaseList(idShop?: number) {
  // See `getCampaignsAutomationBaseList` — idShop unlocks per-shop
  // `shop_integration_status` resolution for items published by integrations.
  const response = await nestCall(
    'get',
    NestApiType.DEFAULT,
    '/workflow/base-config/campaign_bulk_base_list',
    {},
    '',
    undefined,
    true,
    idShop ? { idShop } : {},
  );

  return response?.value || [];
}

export async function getBulkCampaignStatus(id: number): Promise<Maybe<CampaignsBulkStatusEnum>> {
  const params = {
    fields: ['status'],
  };

  const response = await nestCall(
    'get',
    NestApiType.CLIENT_API,
    `/campaigns/bulk/${id}`,
    {},
    '',
    undefined,
    true,
    params,
  );

  if (!response || response.error) {
    await showToastError(response?.error?.message || 'Error fetching campaign status');
    return null;
  }

  return response.data?.status as CampaignsBulkStatusEnum;
}
